module.exports = __webpack_public_path__ + "static/media/diagram_02.27a87804.svg";